module.exports = __webpack_public_path__ + "media/images/menu/pasiphae-411901996a5397cd01a8a69a8c7fb097.jpg";